import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_infmtoasepri.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	validar(p_email, p_usuario, p_fdesde, p_fhasta){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infmtoasepri.validar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_fdesde": p_fdesde,
				"p_fhasta": p_fhasta
				})
		})
	},

	recuperar(p_email, p_usuario, p_poliza, p_fdesde, p_fhasta){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infmtoasepri.recuperar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_fdesde": p_fdesde,
				"p_fhasta": p_fhasta
				})
		})
	},


}